import { VerticalSpacing } from '@banhala/ui-kit';
import { AiFittingRoomBanner } from '../../../../../AiFittingRoomBanner';

export const AiFittingRoomSizeButton = () => {
  return (
    <>
      <AiFittingRoomBanner
        entryPoint="GOODS_DETAIL_REVIEW"
        tab="REVIEW_LIST"
      />
      <VerticalSpacing size={16} />
    </>
  );
};